
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import Constants from '../settings/ui';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    isCorrect: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 40,
    },
    color: {
      type: String,
      default: Constants.colorPalette.blackboard,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName(): String {
      return this.isCorrect ? 'check' : 'close';
    },
  },
});
